export interface ConfigurationApiListItem {
    configurationApiId: string;
    name: string;
    description: string;
}
export interface ConfigurationApiTableItem {
    [key: string]: string | JSX.Element;
    name: string;
    description: string;
    actions: JSX.Element;
}

export enum apiTypeId {
    SIOEO = 1,
    SIOEPKZ = 2,
}

export type ExternalSystem = 'Sioeo' | 'Sioepkz';

export interface ConfigurationApiDetails {
    configurationApiId: string;
    name: string;
    description: string;
    servicesHost: string;
    secretNameFirstValue: string;
    secretNameSecondValue: string;
    apiTypeId: apiTypeId;
    syncTimeMinutes: number;
}